import type { ListBooksParams } from "../api/client";

export const queryKeys = {
  books: (params: ListBooksParams = {}) => ["books", params] as const,
  book: (id: string) => ["book", id] as const,
  bookContent: (id: string) => ["book-content", id] as const,
  bookSummary: (id: string) => ["book-summary", id] as const,
  categories: () => ["categories"] as const,
  settings: () => ["settings"] as const,
  health: () => ["health"] as const,
  authStatus: () => ["auth-status"] as const,
};
